import { NgModule } from '@angular/core';
import { CommonModule, NgSwitch } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDatepickerModule, NgbModalModule, NgbTimepickerModule, NgbTooltipModule, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { ProjectsRoutingModule } from './projects-routing.module';
import { ArchwizardModule } from 'angular-archwizard';
// import { CustomFormsModule } from 'ngx-custom-validators';
// import { UiSwitchModule } from 'ngx-ui-switch';
// import { TagInputModule } from 'ngx-chips';
import { NgSelectModule } from '@ng-select/ng-select';
import { QuillModule } from 'ngx-quill';
import { ClipboardModule } from 'ngx-clipboard';
import { NgxSpinnerModule } from 'ngx-spinner';
// import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'app/shared/shared.module';
// import { MatchHeightModule } from 'app/shared/directives/match-height.directive';

import { StoryComponent } from './story/story.component';
import { TestComponent } from './test/test.component';
import { ConfigurationComponent } from './configuration/configuration.component';

import { NotesComponent } from './story/notes/notes.component';
import { CoverageComponent } from './test/coverage/coverage.component';
import { StoryViewerComponent } from './story/story-viewer/story-viewer.component';
import { ColumnsComponent } from './configuration/columns/columns.component';
import { ManageComponent } from './configuration/manage-columns/manage.component';
import { DownloaderComponent } from './test/downloader/downloader.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { TemplateComponent } from './template/template.component';
import { TagComponent } from './template/tag/tag.component';
import { TestTableComponent } from './test/test-table/test-table.component';
import { TestFileUploadComponent } from './test/test-file-upload/test-file-upload.component';
import { CriterionComponent } from './template/criterion/criterion.component';
import { RigeneraTestModalComponent } from './elements/modals/rigenera-test-modal/rigenera-test-modal.component';
import { DataParamTableComponent } from './template/data-param-table/data-param-table.component';
import { SessionManagerComponent } from './session-manager/session-manager.component';
import { AmbiguitiesAlertComponent } from './elements/ambiguities-alert/ambiguities-alert.component';
import { KnowledgeBaseComponent } from './knowledge-base/knowledge-base.component';
import { StoryHighlightComponent } from './story/story-highlight/story-highlight.component';
import {ChartsModule} from 'ng2-charts';
import { DocumentHighlighterComponent } from './knowledge-base/document-highlighter/document-highlighter.component';
import { VectorSpaceComponent } from './knowledge-base/vector-space/vector-space.component';
import { ClusterReportComponent } from './knowledge-base/cluster-report/cluster-report.component';
import { MicroScenarioTestGeneratorComponent } from './template/micro-scenario-test-generator/micro-scenario-test-generator.component';
import { EditTestsModalComponent } from './template/micro-scenario-test-generator/edit-tests-modal/edit-tests-modal.component';
import { TestbookComponent } from './test/testbook/testbook.component';
import { TraceMatrixComponent } from './template/trace-matrix/trace-matrix.component';
import { InferenceSettingsModalComponent } from './story/inference-settings-modal/inference-settings-modal.component';
import { ProjectDocumentsComponent } from './knowledge-base/project-documents/project-documents.component';
import { KnowledgeBaseTableComponent } from './knowledge-base/knowledge-base-table/knowledge-base-table.component';
import { FileContentViewerComponent } from './knowledge-base/file-content-viewer/file-content-viewer.component';
import { ThreeColumnWorkspaceComponent } from './template/three-column-workspace/three-column-workspace.component';
import {TextareaAutosizeDirective} from '../../shared/directives/textarea-autosize.directive';
import { KnowledgeBaseChatComponent } from './knowledge-base/knowledge-base-chat/knowledge-base-chat.component';
import { ExecutionPlanComponent } from './elements/execution-plan/execution-plan.component';
import { StoryInteractiveComponent } from './story/story-interactive/story-interactive.component';


@NgModule({
  imports: [
    CommonModule,
    ProjectsRoutingModule,
    // TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModalModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    ArchwizardModule,
    NgbTooltipModule,
    SharedModule,
    NgxSpinnerModule,
    NgSelectModule,
    NgbModule,
    QuillModule.forRoot(),
    ClipboardModule,
    // CustomFormsModule,
    // UiSwitchModule,
    // TagInputModule,
    // MatchHeightModule,
    HttpClientModule,
    DragDropModule,
    ChartsModule,
    TextareaAutosizeDirective
  ],
  providers: [
    DownloaderComponent,
  ],
  exports: [],
  declarations: [
    StoryComponent,
    TestComponent,
    ConfigurationComponent,
    NotesComponent,
    CoverageComponent,
    StoryViewerComponent,
    ColumnsComponent,
    ManageComponent,
    TemplateComponent,
    TagComponent,
    TestTableComponent,
    TestFileUploadComponent,
    CriterionComponent,
    RigeneraTestModalComponent,
    DataParamTableComponent,
    SessionManagerComponent,
    AmbiguitiesAlertComponent,
    KnowledgeBaseComponent,
    StoryHighlightComponent,
    DocumentHighlighterComponent,
    VectorSpaceComponent,
    ClusterReportComponent,
    MicroScenarioTestGeneratorComponent,
    EditTestsModalComponent,
    TestbookComponent,
    TraceMatrixComponent,
    InferenceSettingsModalComponent,
    ProjectDocumentsComponent,
    KnowledgeBaseTableComponent,
    FileContentViewerComponent,
    ThreeColumnWorkspaceComponent,
    KnowledgeBaseChatComponent,
    ExecutionPlanComponent,
    StoryInteractiveComponent
  ],
})
export class ProjectsModule { }
